(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jamesallen-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var tabs = document.querySelectorAll('.ja-tab');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var target = tab.getAttribute('data-target');
      tabs.forEach(t => t.classList.remove('active'));
      document.querySelectorAll('.ja-content').forEach(c => c.classList.remove('active'));
      tab.classList.add('active');
      document.getElementById(target).classList.add('active');
    });
  });
  if (tabs.length) tabs[0].click();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["work"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    Fancybox.bind("[data-fancybox='gallery']", {
        Toolbar: {
            display: [
                "zoom",
                "download",
                "close"
            ]
        },
        loop: true
    });
});

  } catch(e) { console.error(e); }
})();
})();
